import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const TravelParticipants = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const participants = booking.bookingDetails.travelParticipatns;

  return (
    <>
      <p>
        <strong> {t("bookingDetails.overview.travelParticipants")}: </strong>
      </p>
      {participants && participants.length > 0 && (
        <>
          {participants.map((participant, i: any) => (
            <p key={i} className="m-0">
              {participant}
            </p>
          ))}
        </>
      )}
    </>
  );
};

export default TravelParticipants;
